import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserDetail,
  userPasswordGenrate,
  forceLogoutUser,
  userRoleAndParentChange,
} from "reduxStore/action/usersActions";
import { useParams } from "react-router-dom";
import Select from "react-select";
import strings from "translate/language";
import {
  getAge,
  isEmpty,
  seo,
  handleListResponse,
  handleDetailResponse,
} from "utils/utils";
import {
  AdminRoleId,
  BusinessHead,
  CallCenter,
  ClusterHead,
  HR,
  PostSale,
  Receptionist,
  SiteHead,
  SubAdmin,
  SupportRequest,
  genderCheck,
} from "utils/constants";
import moment from "moment";
import Breadcrumb from "component/common/breadcrumb";

import { getRoleList } from "reduxStore/action/roleActions";
import { getUserFilterDetail } from "reduxStore/action/usersActions";
import { getActivePropertys } from "reduxStore/action/chatActions";
import {
  ChannelPartner,
  CPAgent,
  ClosingManager,
  SourcingManager,
  SourcingTL,
  ClosingTL,
} from "utils/constants";
import { universalRemoveAction } from "reduxStore/action/authActions";
import {
  GET_ACTIVE_PROPERTY_LIST,
  USER_ROLE_AND_PARENT_CHANGE,
} from "reduxStore/types";
import { removeModalClass } from "utils/modalHandler";
import usePermission from "utils/usePermission";
import ProfileAvatar from "component/common/ProfileAvatar";
import JustoPasswordResetModal from "component/common/JustoPasswordResetModal";
import JustoForceLogoutModal from "component/common/JustoForceLogoutModal";
import "./UserListing.css";
import "component/common/JustoConfirmModal.css";

const displayValue = (value) => {
  if (value === null || value === undefined || String(value).trim() === "") {
    return strings.notavailable;
  }
  return value;
};

const FactCell = ({ label, value, capitalize = false }) => (
  <div className="justo-user-detail__fact">
    <span className="justo-user-detail__fact-label">{label}</span>
    <span
      className={`justo-user-detail__fact-value${
        capitalize ? " justo-user-detail__fact-value--cap" : ""
      }`}
    >
      {value}
    </span>
  </div>
);

const FactSection = ({ title, children }) => (
  <div className="justo-user-detail__section">
    <h2 className="justo-user-detail__section-title">{title}</h2>
    <div className="justo-user-detail__facts">{children}</div>
  </div>
);

const formatDateTime = (value) =>
  value ? moment(value).format("DD-MM-yyyy hh:mm a") : strings.notavailable;

const ViewUser = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const { user_id = "" } = params || {};
  const [formVaild, setFormVaild] = useState({});
  const [form, setForm] = useState({});
  const [userList, setUserList] = useState([]);
  const [rolesList, setRolesList] = useState([]);
  const [activeProperties, setActiveProperties] = useState([]);
  const [isHeadTL, setIsHeadTL] = useState(false);
  const [isPropertyAllocate, setIsPropertyAllocate] = useState(false);
  const [profileDetail, setProfileDetail] = useState({});
  const [passwordResetOpen, setPasswordResetOpen] = useState(false);
  const [passwordResetSubmitting, setPasswordResetSubmitting] = useState(false);
  const [forceLogoutOpen, setForceLogoutOpen] = useState(false);
  const [forceLogoutSubmitting, setForceLogoutSubmitting] = useState(false);
  const getRoleListSelector = useSelector((state) => state.roleData);
  const userListSelector = useSelector((state) => state.userData);
  const chatSelector = useSelector((state) => state.chatResponse);
  const loginSelector = useSelector((state) => state.login);

  const { edit } = usePermission({
    edit: "edit_user",
  });

  useEffect(() => {
    const { response } = getRoleListSelector;
    if (response) {
      if (response?.status === 200) {
        let filterData = handleListResponse(response.data).filter(
          (i) =>
            i._id !== CPAgent &&
            i._id !== ChannelPartner &&
            i._id !== HR &&
            i._id !== PostSale &&
            i._id !== Receptionist &&
            i._id !== CallCenter &&
            i._id !== SubAdmin &&
            i._id !== SupportRequest
        );
        setRolesList(filterData);
      } else {
        setRolesList([]);
      }
    }
  }, [getRoleListSelector]);
  useEffect(() => {
    const { activeProperties } = chatSelector;
    if (activeProperties) {
      if (activeProperties?.status === 200) {
        setActiveProperties(handleListResponse(activeProperties?.data));
      } else {
        setActiveProperties([]);
      }
    }
  }, [chatSelector]);

  const handleInputField = (e) => {
    var nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
      propertyObj: [],
    };
    if (e.target.name === "role_id") {
      nextFormState = {
        ...form,
        isHeadTL: "",
        [e.target.name]: e.target.value,
      };
    }
    dispatch(
      getActivePropertys({
        user_id: e.target.value,
      })
    );

    dispatch(
      getUserFilterDetail({
        limit: 500,
        offset: 0,
      })
    );

    setForm(nextFormState);
  };
  const handleValid = () => {
    let err = {};
    let formError = false;
    if (!form.role_id) {
      formError = true;
      err["role_id"] = strings.role_idErr;
    }
    if (!form.isHeadTL) {
      formError = true;
      err["is_head_tl"] = strings.parentErr;
    } else if (form.isHeadTL === strings.selectParent) {
      formError = true;
      err["is_head_tl"] = strings.parentErr;
    }
    if (form.propertyObj?.length === 0 || form.propertyObj === undefined) {
      formError = true;
      err["propertyObj"] = strings.propertyErr;
    }
    if (!isEmpty(err)) {
      formError = true;
    }
    setFormVaild(err);
    return formError;
  };
  const handleChangeRole = () => {
    if (!handleValid()) {
      let params = {
        role_id: form.role_id,
        user_id: user_id,
        property_id: null,
        parent_id: null,
      };
      if (!isEmpty(form?.propertyObj)) {
        params.property_id = form?.propertyObj.map((i) => i._id);
      }
      if (!isEmpty(form?.isHeadTL)) {
        params.parent_id = form?.isHeadTL;
      }
      dispatch(userRoleAndParentChange(params));
    }
  };
  useEffect(() => {
    seo({
      title: "User Details",
      metaDescription: "View user details",
      canonicalLink: window.location.href,
    });
  }, []);
  useEffect(() => {
    dispatch(getUserDetail({ user_id }));
    dispatch(getRoleList());
  }, [dispatch, user_id]);

  useEffect(() => {
    const { userData, roleChange, create, detail } = userListSelector;
    if (userData) {
      if (userData?.status === 200) {
        const list = handleListResponse(userData?.data).filter((el) => {
          return form.role_id === ClosingManager
            ? el?.role_id === ClosingTL
            : form.role_id === SourcingManager
              ? el?.role_id === SourcingTL
              : form.role_id === ClosingTL || form.role_id === SourcingTL
                ? el?.role_id === SiteHead ||
                el?.role_id === ClusterHead ||
                el?.role_id === BusinessHead ||
                el?.role_id === AdminRoleId
                : form.role_id === SiteHead
                  ? el?.role_id === ClusterHead ||
                  el?.role_id === BusinessHead ||
                  el?.role_id === AdminRoleId
                  : form.role_id === ClusterHead
                    ? el?.role_id === BusinessHead || el?.role_id === AdminRoleId
                    : form.role_id === BusinessHead
                      ? el?.role_id === AdminRoleId
                      : "";
        });
        // setUserList(handleListResponse(userData?.data));
        setUserList(list);
      } else {
        setUserList([]);
      }
    }
    if (roleChange) {
      dispatch(universalRemoveAction(USER_ROLE_AND_PARENT_CHANGE));
      dispatch(universalRemoveAction(GET_ACTIVE_PROPERTY_LIST));
      if (isPropertyAllocate) {
        removeModalClass("propertyAllocate");
        setIsPropertyAllocate(false);
      } else {
        removeModalClass("roleChange");
      }
      dispatch(getUserDetail({ user_id }));
    }
    if (create) {
      if (userData?.status === 200) {
        setForm({});
        dispatch(getUserDetail({ user_id }));
      }
    }
    if (detail) {
      if (userData?.status === 200) {
        const data = handleDetailResponse(userData.data);
        setProfileDetail(data);
        setForm({
          role_id: data?.role_id,
          sourcing_head: data?.sourcing_head,
          isHeadTL: data?.sourcing_head,
          parentUser: handleDetailResponse(
            userList.filter((i) => i._id === data?.sourcing_head)
          ),
        });
        // Do NOT fetch parent/filter users here — that overwrites the shared
        // user list Redux slice (often unbounded) and breaks listing on back.
        // Role-change / property-allocate modals fetch when opened.
        setIsHeadTL(true);
      }
    }
  }, [dispatch, userListSelector, form.role_id]);

  const handlePassword = async ({ send_email } = {}) => {
    if (isEmpty(user_id)) {
      return;
    }
    setPasswordResetSubmitting(true);
    try {
      await dispatch(
        userPasswordGenrate({
          user_id,
          send_email: Boolean(send_email),
        })
      );
      setPasswordResetOpen(false);
    } finally {
      setPasswordResetSubmitting(false);
    }
  };

  const handleForceLogout = async () => {
    if (isEmpty(user_id)) {
      return;
    }
    setForceLogoutSubmitting(true);
    try {
      await dispatch(forceLogoutUser({ user_id }));
      setForceLogoutOpen(false);
    } finally {
      setForceLogoutSubmitting(false);
    }
  };

  const fullName = `${profileDetail?.firstname || ""} ${
    profileDetail?.lastname || ""
  }`.trim();

  const closingPercentage = profileDetail?.user_states?.total_closing_percentage
    ? Number(
        profileDetail?.user_states?.total_closing_percentage.replace("%", "")
      ).toFixed(2) + "%"
    : strings.notavailable;

  const allocatedProperties =
    profileDetail?.allocated_property &&
    profileDetail?.allocated_property.length > 0
      ? profileDetail?.allocated_property
          .map((item) => item?.property_title)
          .join(", ")
      : strings.notavailable;

  const isActive =
    profileDetail?.status === true ||
    profileDetail?.status === 1 ||
    profileDetail?.status === "1" ||
    profileDetail?.status === "true";

  return (
    <div className="page-body justo-user-page">
      <Breadcrumb
        title={strings.userDetails}
        url={"/user"}
        parentListing={strings.userListing}
        titleactive={strings.viewuserdetails}
        isBackBtn={true}
      />
      <div className="container-fluid justo-user">
        <div className="justo-user__card justo-user-detail">
          <div className="justo-user-detail__hero">
            <div className="justo-user-detail__hero-avatar">
              <ProfileAvatar
                variant="detail"
                baseUrl={profileDetail?.base_url}
                profilePicture={profileDetail?.profile_picture}
                alt={fullName || strings.userDetails}
              />
            </div>
            <div className="justo-user-detail__hero-main">
              <h1 className="justo-user-detail__name">
                {fullName || strings.notavailable}
              </h1>
              <p className="justo-user-detail__meta">
                <span>{displayValue(profileDetail?.role_title)}</span>
                <span>{displayValue(profileDetail?.email)}</span>
                <span>{displayValue(profileDetail?.mobile)}</span>
              </p>
            </div>
            <div className="justo-user-detail__hero-actions">
              <span
                className={`user-status-badge ${
                  isActive
                    ? "user-status-badge--active"
                    : "user-status-badge--inactive"
                }`}
              >
                <i
                  className={`fa ${
                    isActive ? "fa-check-circle" : "fa-exclamation-circle"
                  } user-status-badge__icon`}
                  aria-hidden="true"
                />
                <span>{isActive ? strings.active : strings.deactive}</span>
              </span>
              {edit && (
                <>
                  <button
                    type="button"
                    className="justo-user__btn justo-user__btn--outline"
                    onClick={() => setForceLogoutOpen(true)}
                  >
                    {strings.forceLogoutUser}
                  </button>
                  <button
                    type="button"
                    className="justo-user__btn justo-user__btn--solid"
                    onClick={() => setPasswordResetOpen(true)}
                  >
                    {strings.userPasswordSend}
                  </button>
                </>
              )}
            </div>
          </div>

          <div className="justo-user-detail__stats">
            <div className="justo-user-detail__stat">
              <span className="justo-user-detail__stat-label">
                {strings.noOfBooking}
              </span>
              <span className="justo-user-detail__stat-value">
                {profileDetail?.user_states?.total_booking || 0}
              </span>
            </div>
            <div className="justo-user-detail__stat">
              <span className="justo-user-detail__stat-label">
                {strings.noOfCloseVisit}
              </span>
              <span className="justo-user-detail__stat-value">
                {profileDetail?.user_states?.total_closing_lead || 0}
              </span>
            </div>
            <div className="justo-user-detail__stat">
              <span className="justo-user-detail__stat-label">
                {strings.closingPercentage}
              </span>
              <span className="justo-user-detail__stat-value">
                {closingPercentage}
              </span>
            </div>
            <div className="justo-user-detail__stat">
              <span className="justo-user-detail__stat-label">
                {strings.lastLogin}
              </span>
              <span className="justo-user-detail__stat-value">
                {formatDateTime(profileDetail?.user_states?.last_login)}
              </span>
            </div>
          </div>

          <div className="justo-user-detail__content">
            <div className="justo-user-detail__grid">
              <FactSection title="Profile">
                <FactCell
                  label={strings.justoEmp}
                  value={displayValue(profileDetail?.justo_employee_code)}
                  capitalize
                />
                <FactCell
                  label={strings.firstName}
                  value={displayValue(profileDetail?.firstname)}
                  capitalize
                />
                <FactCell
                  label={strings.lastName}
                  value={displayValue(profileDetail?.lastname)}
                  capitalize
                />
                <FactCell
                  label={strings.gender}
                  value={displayValue(genderCheck[profileDetail?.gender])}
                />
                <FactCell
                  label={strings.age}
                  value={
                    profileDetail?.dateofbirth
                      ? getAge(profileDetail?.dateofbirth)
                      : strings.notavailable
                  }
                />
                <FactCell
                  label={strings.createdDate}
                  value={formatDateTime(profileDetail?.created_date)}
                />
              </FactSection>

              <FactSection title="Contact">
                <FactCell
                  label={strings.emailAddress}
                  value={displayValue(profileDetail?.email)}
                />
                <FactCell
                  label={strings.mobileNo}
                  value={displayValue(profileDetail?.mobile)}
                />
                <FactCell
                  label={strings.aadharNo}
                  value={displayValue(profileDetail?.adhar_no)}
                />
                <FactCell
                  label={strings.pancardNo}
                  value={displayValue(profileDetail?.pancard_no)}
                />
                <FactCell
                  label={strings.city}
                  value={displayValue(profileDetail?.city)}
                />
                <FactCell
                  label={strings.address}
                  value={displayValue(profileDetail?.address)}
                  capitalize
                />
                <FactCell
                  label={strings.area}
                  value={displayValue(profileDetail?.area)}
                />
              </FactSection>

              <FactSection title="Role & Assignment">
                <FactCell
                  label={strings.role}
                  value={displayValue(profileDetail?.role_title)}
                />
                <FactCell
                  label={strings.parentname}
                  value={displayValue(profileDetail?.parent_name)}
                  capitalize
                />
                <FactCell
                  label={strings.projectsName}
                  value={allocatedProperties}
                  capitalize
                />
              </FactSection>
            </div>

            <div className="justo-user-detail__grid justo-user-detail__grid--wide">
              <FactSection title="Activity">
                <FactCell
                  label={strings.lastLogin}
                  value={formatDateTime(profileDetail?.user_states?.last_login)}
                />
                <FactCell
                  label={strings.lastVisitAttend}
                  value={formatDateTime(
                    profileDetail?.user_states?.last_site_visit
                  )}
                />
                <FactCell
                  label={strings.lastBooking}
                  value={formatDateTime(
                    profileDetail?.user_states?.last_booking
                  )}
                />
                <FactCell
                  label={strings.lastCloseVisit}
                  value={formatDateTime(
                    profileDetail?.user_states?.last_closing_lead
                  )}
                />
              </FactSection>
            </div>
          </div>
        </div>
      </div>
      {/* Reset password confirm */}
      <JustoPasswordResetModal
        open={passwordResetOpen}
        onClose={() =>
          !passwordResetSubmitting && setPasswordResetOpen(false)
        }
        onConfirm={handlePassword}
        submitting={passwordResetSubmitting}
        userName={
          [profileDetail?.firstname, profileDetail?.lastname]
            .filter(Boolean)
            .join(" ") || profileDetail?.user_name
        }
        email={profileDetail?.email}
        mobile={profileDetail?.mobile}
      />
      <JustoForceLogoutModal
        open={forceLogoutOpen}
        onClose={() => !forceLogoutSubmitting && setForceLogoutOpen(false)}
        onConfirm={handleForceLogout}
        submitting={forceLogoutSubmitting}
        userName={
          [profileDetail?.firstname, profileDetail?.lastname]
            .filter(Boolean)
            .join(" ") || profileDetail?.user_name
        }
        email={profileDetail?.email}
        mobile={profileDetail?.mobile}
      />
      {/* Role Change Modal */}
      <div
        className="modal fade"
        id="roleChange"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {strings.roleChange}
              </h5>
              <button
                className="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label htmlFor="exampleFormControlSelect9">
                      {strings.role}
                      <span className="required-field"></span>
                    </label>
                    <select
                      className="form-control digits"
                      name="role_id"
                      value={form.role_id}
                      onChange={handleInputField}
                    >
                      <option value="">{strings.selectRole}</option>
                      {rolesList.map((item, index) => (
                        <option key={index} value={item._id}>
                          {item.role_title}
                        </option>
                      ))}
                    </select>
                    {formVaild?.role_id && (
                      <span style={{ color: "red" }}>{formVaild?.role_id}</span>
                    )}
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="mb-3">
                    <label htmlFor="exampleFormControlSelect9">
                      {strings.parent}
                      <span className="required-field"></span>
                    </label>
                    <select
                      className="form-control digits"
                      name="isHeadTL"
                      value={form.isHeadTL}
                      onChange={handleInputField}
                    >
                      <option value="">{strings.selectParent}</option>
                      {userList.map((item, index) => (
                        <option key={index} value={item._id}>
                          {`${item.firstname} ${item.lastname} (${item?.role_title})`}
                        </option>
                      ))}
                    </select>
                    {formVaild?.is_head_tl && (
                      <span style={{ color: "red" }}>
                        {formVaild?.is_head_tl}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="mt-3">
                    <label htmlFor="exampleFormControlSelect9">
                      {strings.property}
                      <span className="required-field"></span>
                    </label>
                    <Select
                      isSearchable
                      isMulti
                      isClearable
                      options={activeProperties}
                      getOptionLabel={(option) => `${option.property_title}`}
                      getOptionValue={(option) => option._id}
                      name="propertyObj"
                      value={form?.propertyObj}
                      onChange={(val) => {
                        const nextFormState = {
                          ...form,
                          propertyObj: val,
                        };
                        setForm(nextFormState);
                      }}
                    />
                    {formVaild?.propertyObj && (
                      <span style={{ color: "red" }}>
                        {formVaild?.propertyObj}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                className="btn btn-success mr-5"
                type="button"
                onClick={() => handleChangeRole()}
              >
                {strings.update}
              </button>
              <button
                className="btn btn-primary"
                type="button"
                data-dismiss="modal"
              >
                {strings.cancel}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Property Allocate Modal */}
      <div
        className="modal fade"
        id="propertyAllocate"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {strings.propertyAllocate}
              </h5>
              <button
                className="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="col-md-12">
                <div className="mb-1">
                  <label htmlFor="exampleInputMobileNo">
                    {strings.allocatedProps} :-
                  </label>
                </div>
                <label htmlFor="exampleInputMobileNo" className="boldText">
                  {profileDetail?.allocated_property &&
                    profileDetail?.allocated_property.length > 0 ? (
                    <div>
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                        style={{ textTransform: "capitalize" }}
                      >
                        {profileDetail?.allocated_property
                          ?.map((item) => item?.property_title)
                          .join(", ")}
                      </label>
                    </div>
                  ) : (
                    strings.notavailable
                  )}
                </label>
              </div>
              <hr />
              <div className="col-md-12">
                <div className="mb-3">
                  <label htmlFor="exampleFormControlSelect9">
                    {strings.property}
                    <span className="required-field"></span>
                  </label>
                  <Select
                    isSearchable
                    isMulti
                    isClearable
                    options={activeProperties}
                    getOptionLabel={(option) => `${option.property_title}`}
                    getOptionValue={(option) => option._id}
                    name="propertyObj"
                    value={form?.propertyObj}
                    onChange={(val) => {
                      const nextFormState = {
                        ...form,
                        propertyObj: val,
                      };
                      setForm(nextFormState);
                    }}
                  />
                  {formVaild?.propertyObj && (
                    <span style={{ color: "red" }}>
                      {formVaild?.propertyObj}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                className="btn btn-success mr-5"
                type="button"
                onClick={() => handleChangeRole()}
              >
                {strings.update}
              </button>
              <button
                className="btn btn-primary"
                type="button"
                data-dismiss="modal"
              >
                {strings.cancel}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Model_end */}
    </div>
  );
};
export default ViewUser;
